<template>
  <div> 
    <div class="flex items-center justify-between">
      <div class="flex flex-wrap gap-3 items-center">
        <div class="relative m-2 py-2 pl-4 pr-5 cursor-pointer d-theme-dark-bg rounded-md hover:shadow-drop"
          v-for="agent in agentsWithShortfall" :key="agent.index" @click="changeFilter(agent.id)"
            v-bind:style="$route.query.filter && Number($route.query.filter) === Number(agent.id) ? 'background: red; color: white' : (!$route.query.filter || $route.query.filter === '') && agent.id === '' ? 'background: #1c5bfe; color: white;' : ''">
          <div class="text-sm capitalize">{{ agent.first_name }} {{agent.last_name}}</div>
          <div class="text-sm capitalize text-center" v-if="agent.cumulative_shortfall">{{ agent.cumulative_shortfall }}</div>
          <div class="absolute right-0 top-0 w-2 h-full rounded-4xl" :style="agent.id !== '' ? 'background:red' : 'background:#1c5bfe'"></div>
        </div>
      </div>
      <div class="text-center mt-4 grid grid-rows-2 grid-flow-col gap-4" v-if="$route.query.filter !== '' && $route.query.filter">
        <div>
          <vs-button class="ml-auto mt-2" @click="shortfallSettlementModal = true">{{$t('Settle Shortfall')}}</vs-button>
        </div>
        <div>
          <h3>HR ID : {{agents.filter(item => Number($route.query.filter) === Number(item.id)).length > 0 ? agents.filter(item => Number($route.query.filter) === Number(item.id))[0].hr_id : ''}}</h3>
        </div>
      </div>
    </div>
    <shipblu-table :sst="true" :data="allAgents" orders :tableLoader="tableLoader" :hideHeader="true" class="mt-4">
      <template slot="thead">
        <shipblu-th>{{$t('ID')}}</shipblu-th>
        <shipblu-th>{{$t('Amount')}}</shipblu-th>
        <shipblu-th>{{$t('Issued By')}}</shipblu-th>
        <shipblu-th>{{$t('Transaction Date')}}</shipblu-th>
        <shipblu-th>{{$t('Created On')}}</shipblu-th>
        <shipblu-th>{{$t('Reference Number')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="data[indextr].type === 'shortfall' ? 'red' : '#1c5bfe' ">
          <shipblu-td class="order-3" :data="data[indextr].id">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('ID')}}</p>
            <p class="sm:text-base text-sm text-black">
              {{ data[indextr].id}}
            </p>
          </shipblu-td>
          <shipblu-td class="sm:hidden block col-span-2 p-6 order-2">
            <!-- line -->
            <p style="background-color: #DCDCDC;height: 1px;"></p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].tracking_number" class="text-left sm:order-3 order-11 sm:pointer-events-none">
            <div class="flex sm:static absolute top-3 gap-2 items-start justify-start transform-50">
              <p class="sm:text-base text-lg flex gap-1 items-start justify-center">
                <span :class="data[indextr].amount && data[indextr].amount > 0 ? '' : 'text-red'">
                  {{ data[indextr].amount ? data[indextr].amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '' }}
                </span>
              </p>
            </div>
          </shipblu-td>

          <shipblu-td class="order-5" :data="data[indextr].created_by">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Issued By')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].created_by.first_name + ' ' + data[indextr].created_by.last_name }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-5" :data="data[indextr].created">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Transaction Date')}}</p>
            <p class="sm:text-base text-sm">{{ new Date(data[indextr].created).toLocaleDateString('fr-CA') }}</p>
          </shipblu-td>

          <shipblu-td class="order-6" :data="data[indextr].created">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Created On')}}</p>
            <p class="sm:text-base text-sm">{{ new Date(data[indextr].created).toLocaleDateString('fr-CA') }}</p>
            <p class="sm:text-base text-sm">{{ new Date(data[indextr].created).toLocaleTimeString('en-GB') }}</p>
          </shipblu-td>

          <shipblu-td class="order-7" :data="data[indextr].reference">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Reference Number')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].reference }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].agent" style="color: green">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Status')}}</p>
            <div class="flex" style="width: fit-content;">
              <span class="capitalize border border-solid rounded-4xl px-5 py-1.5 leading-none sm:text-sm text-xs text-white" style="background-color:green">{{$t('Approved')}}</span>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination  :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />
    <shortfall-settlement @agentShortfalls="agentShortfalls" :agent="agents.filter(item => Number($route.query.filter) === Number(item.id))[0]" :shortfallSettlementModal="shortfallSettlementModal" :userType="userType" @shortfallSettlementModal="shortfallSettlementModal = $event" :filters="filters" @filters="filters = $event"></shortfall-settlement>
  </div>
</template>

<script>
import common  from '@/assets/utils/common'
import {sendRequest} from '../../../http/axios/requestHelper.js'
import ShipbluTable from '../../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../layouts/components/ShipBluTd.vue'
import ShortfallSettlement from './ShortfallSettlement.vue'
import ShipbluPagination from '../../../layouts/components/ShipbluPagination.vue'

export default {
  data () {
    return {
      shortfallSettlementModal: false,
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      khaznaTransactionModal: false,
      type: '',
      agents: [],
      warehousesDic: {},
      allAgents: [],
      filters: '',
      totalRows: 0,
      tableLoader: false,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      offset: 0,
      agentsWithShortfall: [],
      userType:'finance'
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          filterTab: this.$route.query.filterTab,
          filter: this.filters,
          page: this.currentPage
        }
      }).catch(() => {})
      this.agentShortfalls()
    },
    'filters' (val) {
      this.currentPage = 1
      this.$router.push({
        query: {
          filter: val,
          page: this.currentPage,
          filterTab: this.$route.query.filterTab
        }
      }).catch(() => {})
    }
  },
  methods: {
    formatWarehouses (warehouses) {
      warehouses.forEach(warehouse => {
        this.warehousesDic[warehouse.code] = warehouse.id
      })
      this.agentShortfalls()
    },
    changeFilter (value) {
      this.filterValue = value
      this.filters = this.filterValue
      if (this.filterValue === 'all') {
        this.filters = ''
      }
      this.currentPage = 1
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          filterTab: this.$route.query.filterTab,
          page: this.currentPage
        }
      }).catch(() => {})
      this.agentShortfalls()
    },
    agentShortfalls () {
      this.tableLoader = true
      const query = `?primary_warehouse=${this.$route.params.warehouseID}&agent_id=${this.$route.query.filter ? this.$route.query.filter : ''}&offset=${this.offset}&limit=${this.maximumItems}`
      sendRequest(true, false, this, `api/v1/accounting/agent-shortfalls/${query}`, 'get', null, true,
        (response) => {
          this.allAgents = response.data.results
          this.tableLoader = false
          this.totalRows = response.data.count
          this.loadAgents()
        }
      )
    },
    loadAgents () {
      sendRequest(false, false, this, `api/v1/warehouse/${this.$route.params.warehouseID}/agents/customer_agent/?limit=100&include_deleted=true&cumulative_shortfall_gt=0`, 'get', null, true, 
        (response) => {
          this.agents = response.data.results
          this.agentsWithShortfall = this.agents
          this.agentsWithShortfall.unshift({
            first_name: 'All',
            id: ''
          })
        }
      )
    },
    openKhaznaModal (type) {
      this.type = type
      this.khaznaTransactionModal = true
    }
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination,
    ShortfallSettlement
  },
  created () {
    common.manageLoadWarehouses(this.formatWarehouses, this)
    this.offset = (this.currentPage - 1) * this.maximumItems
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
</style>
